export const TEMPLATES_PATH = '/templates';
export const TEMPLATE_NEW_PATH = '/template-new';

export function templateEditPath(id: string): string {
  return `${TEMPLATES_PATH}/${id}`;
}

export function isTemplatesNavPath(pathname: string): boolean {
  return pathname === TEMPLATE_NEW_PATH
    || pathname === TEMPLATES_PATH
    || pathname.startsWith(`${TEMPLATES_PATH}/`)
    || pathname.startsWith('/brand-kits')
    || pathname === '/branding';
}

export function legacyBrandKitRedirect(pathname: string): string | null {
  if (pathname === '/brand-kits' || pathname === '/branding') return TEMPLATES_PATH;
  if (pathname === '/brand-kits-new') return TEMPLATE_NEW_PATH;
  const match = /^\/brand-kits\/([^/]+)$/.exec(pathname);
  return match?.[1] ? templateEditPath(match[1]) : null;
}
